import { Suspense } from "react";
import { Loader } from "../shared/index";

const QueryLoadingBoundary = ({ children }) => {
  return (
    <Suspense
      fallback={
        <div
          style={{
            display: "grid",
            placeItems: "center",
            minHeight: "100vh",
          }}
        >
          {/* <Loader title="GD Mart app loading....." />  */}
        </div>
      }
    >
      {children}
    </Suspense>
  );
};

export default QueryLoadingBoundary;
